module.exports = __webpack_public_path__ + "static/media/unselectedText.0a29bfed.png";